import React, { useState } from 'react';
import './PageStyles.css';
import WaitlistModal from '../components/WaitlistModal';

const ForBuyers = () => {
    const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);

    return (
        <div className="page-container">
            {/* Hero Section */}
            <section className="page-hero">
                <div className="page-hero-content">
                    <h1 className="page-hero-title">For Buyers</h1>
                    <p className="page-hero-subtitle">
                        Find the perfect suppliers and products for your business needs. Connect with verified partners in your industry.
                    </p>
                    <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                </div>
            </section>

            {/* Value Props Section */}
            <section className="value-props-section">
                <div className="value-props-container">
                    <h2 className="section-title">Why Use Colorkarma Directory?</h2>

                    <div className="value-props-grid">
                        <div className="value-prop-card">
                            <div className="value-prop-icon">🔍</div>
                            <h3>Discover New Suppliers</h3>
                            <p>
                                Search through a curated directory of verified suppliers. Find partners you never knew existed,
                                expanding your sourcing options and discovering better products.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">⚡</div>
                            <h3>Save Time & Effort</h3>
                            <p>
                                Stop spending hours searching for suppliers. Our intelligent matching system connects you with
                                the right partners based on your specific needs and requirements.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">✅</div>
                            <h3>Verified Partners</h3>
                            <p>
                                All suppliers are verified and vetted. Browse detailed profiles, certifications, and reviews
                                to make informed decisions about your business partnerships.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">📊</div>
                            <h3>Compare Options</h3>
                            <p>
                                Easily compare products, pricing, and supplier capabilities side-by-side. Make data-driven
                                decisions with all the information you need in one place.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">🎯</div>
                            <h3>Targeted Matching</h3>
                            <p>
                                Get matched with suppliers that meet your specific requirements. Filter by industry, location,
                                certifications, and more to find your perfect match.
                            </p>
                        </div>

                        <div className="value-prop-card">
                            <div className="value-prop-icon">💼</div>
                            <h3>Build Relationships</h3>
                            <p>
                                Connect directly with suppliers, ask questions, and build long-term business relationships.
                                Streamline your procurement process from discovery to partnership.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section">
                <div className="how-it-works-container">
                    <h2 className="section-title">How It Works for Buyers</h2>

                    <div className="steps-container">
                        <div className="step-card">
                            <div className="step-number">1</div>
                            <h3>Create Your Profile</h3>
                            <p>Sign up and create a buyer profile with your company information and requirements.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">2</div>
                            <h3>Search & Browse</h3>
                            <p>Search for products you need or browse supplier profiles by industry, location, and capabilities.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">3</div>
                            <h3>Get Matched</h3>
                            <p>Our system matches you with suppliers that meet your specific needs and requirements.</p>
                        </div>

                        <div className="step-card">
                            <div className="step-number">4</div>
                            <h3>Connect & Partner</h3>
                            <p>Reach out to suppliers, compare options, and build lasting business partnerships.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="page-cta-section">
                <div className="page-cta-content">
                    <h2>Ready to Find Your Perfect Suppliers?</h2>
                    <p>Join our waitlist to get early access and start connecting with verified suppliers in your industry.</p>
                    <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                </div>
            </section>
            <WaitlistModal isOpen={isWaitlistModalOpen} onClose={() => setIsWaitlistModalOpen(false)} />
        </div>
    );
};

export default ForBuyers;

